/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Free shipping label on product pages
   * ------------------------------------
   * Swaps the "Sofort lieferbar" text in the availability bullets of
   * snippets/product.liquid for "Kostenloser Versand" as soon as the
   * threshold from settings.free_shipping_limit would be met by the current
   * cart PLUS the product on screen - so the visitor sees it before adding
   * the item, not only afterwards.
   *
   * Markup comes from snippets/shipping-label.liquid. Liquid already renders
   * the correct initial state; this script keeps it up to date, because the
   * cart changes via AJAX and the price changes on variant switches.
   *
   * Threshold and product price are read off the element - no value is
   * duplicated here, the theme setting stays the single source of truth.
   */
  (function () {
    var SELECTOR = "[data-shipping-label]";

    // Theme events (see assets/theme.js) instead of observing the DOM.
    var CART_EVENTS = [
      "theme:cart:added",
      "theme:cart:loaded",
      "theme:cart:update",
    ];

    // Cached so a variant switch can re-render without re-fetching the cart.
    var cartTotal = null;

    function paint(scope) {
      if (cartTotal === null) return;
      (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
        var limit = parseFloat(el.dataset.limit || "0");
        if (!(limit > 0)) return;
        var productPrice = parseFloat(el.dataset.productPriceCents || "0") / 100;
        el.textContent =
          cartTotal + productPrice >= limit
            ? el.dataset.reached
            : el.dataset.fallback;
      });
    }

    function refresh() {
      // Only on pages that have a label - skips the request everywhere else.
      if (!document.querySelector(SELECTOR)) return;

      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.ok ? res.json() : Promise.reject(res.status);
        })
        .then(function (cart) {
          cartTotal = cart.total_price / 100;
          paint();
        })
        .catch(function () {
          /* On failure the Liquid-rendered state stays as is. */
        });
    }

    CART_EVENTS.forEach(function (name) {
      document.addEventListener(name, refresh);
    });

    /*
     * Bundle apps (FastBundle on the GG Creme page, Fly Bundles, Opus upsell)
     * write to the cart through their own AJAX calls and never fire the theme
     * events above, which left the label stale there until a reload.
     * Watching the network layer catches every cart mutation regardless of
     * which app triggered it. /cart.js itself is a read and not matched, so
     * refresh() cannot trigger itself.
     */
    var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

    function isCartWrite(url) {
      return typeof url === "string" && CART_WRITE.test(url);
    }

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var result = nativeFetch.apply(this, arguments);
        if (isCartWrite(url) && result && result.then) {
          result.then(refresh, function () {});
        }
        return result;
      };
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartWrite(url)) this.addEventListener("load", refresh);
      return nativeOpen.apply(this, arguments);
    };

    // A different variant can carry a different price, which moves the
    // threshold. Scope the update to the section the event came from, so a
    // quick-view popup cannot overwrite the label of the page behind it.
    document.addEventListener("theme:variant:change", function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var scope = event.target.closest
        ? event.target.closest(".shopify-section") || document
        : document;

      scope.querySelectorAll(SELECTOR).forEach(function (el) {
        el.dataset.productPriceCents = variant.price;
      });
      paint(scope);
    });

    refresh();
  })();

  /**
   * Scarcity countdown on the redesigned product page
   * -------------------------------------------------
   * Fills the bar of snippets/gloria-scarcity-countdown.liquid when it
   * scrolls into view, and ticks its timer - when the block has one - down
   * to the daily reset time, starting over the next day.
   *
   * The reset time is read off the element, so the theme setting stays the
   * single source of truth. Liquid renders the first frame in the shop's
   * timezone; from the first tick on the countdown follows the visitor's clock,
   * which is what the reference page does too.
   */
  (function () {
    var SELECTOR = "[data-gl-countdown]";

    function pad(value) {
      return value < 10 ? "0" + value : String(value);
    }

    // Next occurrence of HH:MM in the visitor's timezone.
    function msUntilReset(resetTime) {
      var parts = String(resetTime || "23:59").split(":");
      var hours = parseInt(parts[0], 10);
      var minutes = parseInt(parts[1], 10);
      if (isNaN(hours) || isNaN(minutes)) return 0;

      var now = new Date();
      var target = new Date();
      target.setHours(hours, minutes, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);

      return target - now;
    }

    function tick() {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        var display = el.querySelector("[data-gl-countdown-display]");
        if (!display) return;

        var remaining = Math.max(0, Math.floor(msUntilReset(el.dataset.glResetTime) / 1000));
        display.textContent =
          pad(Math.floor(remaining / 3600)) +
          ":" +
          pad(Math.floor((remaining % 3600) / 60)) +
          ":" +
          pad(remaining % 60);
      });
    }

    // Skips the interval on every page that has no timer - the block can be
    // set up without one.
    if (document.querySelector(SELECTOR + " [data-gl-countdown-display]")) {
      tick();
      setInterval(tick, 1000);
    }

    // Scroll-in: the bar fills and the number counts up to it, once, when
    // the block comes into view. The fill itself is a CSS transition on
    // `is-filled` (custom-ks.css); the count runs on the same curve and
    // duration, so number and bar arrive together. With reduced motion, or
    // without an observer, both show their final state straight away.
    var DURATION = 1600;
    var reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // The curve of cubic-bezier(0.22, 1, 0.36, 1), close enough for a count.
    function easeOutQuint(t) {
      return 1 - Math.pow(1 - t, 5);
    }

    function countUp(el) {
      var target = parseInt(el.getAttribute("data-gl-countdown-value"), 10);
      if (isNaN(target)) return;

      var start = null;
      el.textContent = "0";

      function frame(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / DURATION);
        el.textContent = String(Math.round(target * easeOutQuint(t)));
        if (t < 1) requestAnimationFrame(frame);
      }

      requestAnimationFrame(frame);
    }

    function fill(block) {
      block.classList.add("is-filled");
      if (reduceMotion) return;

      var value = block.querySelector("[data-gl-countdown-value]");
      if (value) countUp(value);
    }

    var observer =
      !reduceMotion && "IntersectionObserver" in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                fill(entry.target);
              });
            },
            // Starts once a good part of the block is on screen, not at its
            // edge.
            { threshold: 0.6 }
          )
        : null;

    function watch(scope) {
      scope.querySelectorAll(SELECTOR).forEach(function (block) {
        if (observer) observer.observe(block);
        else fill(block);
      });
    }

    watch(document);

    // The theme editor re-renders the section on every settings change, with
    // a fresh, empty bar - without this it would stay empty in the preview.
    document.addEventListener("shopify:section:load", function (event) {
      watch(event.target);
    });
  })();

  /**
   * Arrows for the horizontal card strips
   * -------------------------------------
   * Shared by every strip that marks itself up as [data-gl-scroller] - the
   * testimonial row and the results row today. The strips themselves are CSS
   * scroll-snap, so this only moves them by one card and keeps the two buttons
   * honest: hidden while nothing overflows, disabled at either end.
   *
   * Nothing here knows what a card is. The step comes off the rendered strip,
   * so it follows the breakpoint without a single width being repeated in JS.
   */
  (function () {
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    // A scroll asked for in JS animates even where the stylesheet says not to,
    // so the preference has to be read here as well.
    function behavior() {
      return reducedMotion.matches ? "auto" : "smooth";
    }

    document.querySelectorAll("[data-gl-scroller]").forEach(function (scroller) {
      var strip = scroller.querySelector("[data-gl-scroller-strip]");
      var prev = scroller.querySelector("[data-gl-scroller-prev]");
      var next = scroller.querySelector("[data-gl-scroller-next]");
      var card = strip && strip.firstElementChild;
      if (!strip || !prev || !next || !card) return;

      function step() {
        var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        // 2px of slack: a fractional card width never lets scrollLeft reach
        // the theoretical maximum exactly.
        var max = strip.scrollWidth - strip.clientWidth;
        var scrollable = max > 2;

        prev.hidden = !scrollable;
        next.hidden = !scrollable;
        prev.disabled = strip.scrollLeft <= 2;
        next.disabled = strip.scrollLeft >= max - 2;
      }

      prev.addEventListener("click", function () {
        strip.scrollBy({ left: -step(), behavior: behavior() });
      });

      next.addEventListener("click", function () {
        strip.scrollBy({ left: step(), behavior: behavior() });
      });

      strip.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);

      // Once more when images and webfonts have landed: whether a strip
      // overflows is not decided until then.
      window.addEventListener("load", update);
      update();
    });
  })();

  /**
   * Sticky add-to-cart bar on the redesigned product page
   * -----------------------------------------------------
   * Three jobs, all fixing something the reference page gets wrong:
   *
   * 1. The bar appears once the real add-to-cart button has scrolled out of
   *    view, instead of at a fixed scroll offset. The reference switches at
   *    1300px on every breakpoint, which on mobile shows the bar while the
   *    real button is still below the fold - two add-to-carts at once.
   * 2. The price follows the selected variant and the selected bundle tier.
   *    The reference keeps showing the price the page was rendered with.
   * 3. The button adds to the cart. The reference's only scrolls back to
   *    the buy box.
   *
   * The theme's own bar, on every template without the redesign, keeps its
   * scroll handler in sections/product.liquid and is untouched.
   */
  (function () {
    var bar = document.querySelector("#sticky_atc.gl-pdp");
    if (!bar) return;

    // The buy area, not the theme's own add-to-cart button: a bundle app can
    // replace that button with its own and leave the original display:none,
    // which an observer would never see leave the viewport.
    function firstVisible(selectors) {
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetParent && el.getBoundingClientRect().height > 0) return el;
      }
      return null;
    }

    var trigger = firstVisible([
      ".product-single__details .shopbtnwrp",
      ".product-single__details [data-form-wrapper]",
    ]);

    function show(visible) {
      bar.classList.toggle("sticky-visible", visible);
      bar.classList.toggle("sticky-hidden", !visible);
    }

    if (trigger && "IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          // Only once the button has left upwards - not before the page is
          // scrolled past it, and not while the footer is in view.
          var entry = entries[0];
          show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(trigger);
    } else {
      // No observer: fall back to the theme's fixed offset.
      window.addEventListener("scroll", function () {
        show((window.pageYOffset || document.documentElement.scrollTop) > 1000);
      });
    }

    // Mirror the price the buy box shows into the bar, so the money format
    // stays the shop's own and no formatting is duplicated here.
    //
    // Two things rewrite that price: the theme on a variant change, and Fly
    // Bundles when a bundle tier is picked - the app writes its tier price and
    // compare price straight into the same [data-product-price] and
    // [data-compare-price] elements and fires no event. So the wrapper is
    // watched for any change instead, which covers both. The bar is written
    // only when its content actually differs, so the observer never feeds on
    // its own work.
    var priceWrapper = document.querySelector(
      ".product-single__details [data-price-wrapper]"
    );

    function syncPrice() {
      var price = document.querySelector(
        ".product-single__details [data-product-price]"
      );
      var compare = document.querySelector(
        ".product-single__details [data-compare-price]"
      );

      if (price) {
        bar.querySelectorAll("[data-gl-sticky-price]").forEach(function (el) {
          if (el.innerHTML !== price.innerHTML) el.innerHTML = price.innerHTML;
        });
      }

      var barCompare = bar.querySelector("[data-gl-sticky-compare-price]");
      var compareHtml = compare ? compare.innerHTML : "";
      if (barCompare && barCompare.innerHTML !== compareHtml) {
        barCompare.innerHTML = compareHtml;
      }
    }

    document.addEventListener("theme:variant:change", syncPrice);

    if (priceWrapper && "MutationObserver" in window) {
      new MutationObserver(syncPrice).observe(priceWrapper, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // The app may already have applied its preselected tier before this ran.
    syncPrice();

    // The bar's button clicks the buy box's real one. That button belongs to
    // Fly Bundles, so the bundle tier picked there goes into the cart as
    // selected - a second form in the bar would add the plain variant
    // instead. The theme's own button is the fallback for a product without
    // a bundle. With neither clickable (sold out, app not loaded, class names
    // changed in an app update), the link does what it did before and scrolls
    // back to the buy box.
    var cta = bar.querySelector(".gl-sticky-cta");
    if (cta) {
      cta.addEventListener("click", function (event) {
        var button = firstVisible([
          ".product-single__details .gfbVolumeDiscountWidgetOfferAddToCartButton",
          ".product-single__details [data-add-to-cart]",
        ]);
        if (!button || button.disabled) return;

        event.preventDefault();
        button.click();
      });
    }
  })();

  /**
   * Installment line in the redesigned buy box
   * ------------------------------------------
   * "oder 6 monatliche Raten von ..." is rendered by a custom_code block in
   * the sandbox template, from the price the page was loaded with. The buy
   * box price changes afterwards - on a variant change, and when a Fly
   * Bundles tier is picked, which the app writes straight into
   * [data-product-price] without an event. The rate follows it here, with the
   * same arithmetic as the Liquid: the price divided by the number of rates,
   * rounded up to the cent. The line hides below the threshold, as the Liquid
   * leaves it out there.
   */
  (function () {
    var line = document.querySelector(".gl-pdp [data-gl-installments]");
    if (!line) return;

    var amount = line.querySelector("[data-gl-installment-amount]");
    var wrapper = document.querySelector(
      ".product-single__details [data-price-wrapper]"
    );
    var formatMoney =
      window.themeVendor &&
      themeVendor.themeCurrency &&
      themeVendor.themeCurrency.formatMoney;
    if (!amount || !wrapper || !formatMoney || !window.theme) return;

    var count = parseInt(line.getAttribute("data-gl-installments"), 10);
    var min = parseInt(line.getAttribute("data-gl-installments-min"), 10) || 0;

    // The displayed price in cents. German format, "1.234,56 €" -> 123456 -
    // the same reading as the discount badge in snippets/product.liquid.
    function priceInCents() {
      var el = wrapper.querySelector("[data-product-price]");
      var text = el ? (el.textContent || "").replace(/[^\d.,]/g, "") : "";
      if (!text) return null;
      var value = parseFloat(text.replace(/\./g, "").replace(",", "."));
      return isNaN(value) ? null : Math.round(value * 100);
    }

    function update() {
      var price = priceInCents();
      if (price === null || !count) return;

      line.hidden = price <= min;

      // Written only when it differs, like the sticky bar's price.
      var html = formatMoney(Math.ceil(price / count), theme.moneyFormat);
      if (amount.innerHTML !== html) amount.innerHTML = html;
    }

    document.addEventListener("theme:variant:change", update);

    if ("MutationObserver" in window) {
      new MutationObserver(update).observe(wrapper, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // The app may already have applied its preselected tier before this ran.
    update();
  })();

  /**
   * Testimonial slider
   * ------------------
   * Two jobs for sections/gloria-testimonials.liquid, which is a CSS
   * scroll-snap strip rather than a slider library:
   *
   * 1. "Mehr lesen" per card. The quote is clamped to five lines in CSS; the
   *    toggle only appears on the cards where that clamp actually cuts
   *    something off, which is measurable in the browser and nowhere else.
   * 2. The two arrows. They scroll by one card and switch themselves off at
   *    either end. On a strip that does not overflow - few testimonials, wide
   *    screen - they stay hidden entirely.
   *
   * Both labels come out of the section settings via data attributes, so no
   * customer-facing copy lives in this file.
   */
  (function () {
    var sections = document.querySelectorAll("[data-gl-testimonials]");
    if (!sections.length) return;

    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    /**
     * Opens or closes one quote, animating the height it settles at.
     *
     * A content height cannot be transitioned, so both ends are measured and
     * the box is driven between them in pixels. The quote stays unclamped for
     * the whole movement, in either direction: on the way back the clamp would
     * otherwise cut it to five lines in a single frame and leave the box
     * animating over empty space. What it is left with afterwards is decided
     * on transitionend, and the inline height is handed back to the stylesheet
     * there as well.
     */
    function toggleQuote(text, button, labels) {
      // The button's own state, not the class: during a collapse the class is
      // still on the element, and a click in that moment means "open again".
      var expanding = button.getAttribute("aria-expanded") !== "true";

      button.setAttribute("aria-expanded", expanding ? "true" : "false");
      button.textContent = expanding ? labels.less : labels.more;

      if (reducedMotion.matches) {
        text.classList.toggle("is-expanded", expanding);
        return;
      }

      var start = text.getBoundingClientRect().height;

      // Measure the target state before showing it: the class decides whether
      // the clamp applies, and height:auto makes the box report where it would
      // come to rest.
      text.classList.toggle("is-expanded", expanding);
      text.style.height = "auto";
      var end = text.getBoundingClientRect().height;

      text.classList.add("is-expanded");
      text.dataset.glCollapsing = expanding ? "" : "1";
      text.style.height = start + "px";

      // Read the layout back, or both assignments land in one recalculation
      // and there is nothing to transition between.
      void text.offsetHeight;
      text.style.height = end + "px";
    }

    function settleQuote(event) {
      if (event.propertyName !== "height") return;

      var text = event.currentTarget;
      text.style.height = "";
      if (text.dataset.glCollapsing) text.classList.remove("is-expanded");
      delete text.dataset.glCollapsing;
    }

    function setUpReadMore(section) {
      var labels = {
        more: section.dataset.glMoreLabel || "",
        less: section.dataset.glLessLabel || section.dataset.glMoreLabel || "",
      };

      section.querySelectorAll("[data-gl-tm-more]").forEach(function (button) {
        var text = button.parentElement.querySelector("[data-gl-tm-text]");
        var paragraph = text && text.querySelector("p");
        if (!paragraph) return;

        button.hidden = false;

        // A clamped paragraph reports more scroll height than it shows. One
        // pixel of tolerance, because sub-pixel line heights round either way.
        // A quote that fits keeps the button's line but not the button, so the
        // cards stay the same height - see .gl-tm__more--empty.
        if (paragraph.scrollHeight - paragraph.clientHeight < 2) {
          button.classList.add("gl-tm__more--empty");
          return;
        }

        text.addEventListener("transitionend", settleQuote);
        button.addEventListener("click", function () {
          toggleQuote(text, button, labels);
        });
      });
    }

    function setUp() {
      sections.forEach(setUpReadMore);
    }

    // The clamp is measured in rendered lines, so the webfont has to be in
    // before the measurement - a deferred script runs well before that.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setUp);
    } else {
      setUp();
    }
  })();

  /**
   * VIP sign-up form
   * ----------------
   * Markup comes from sections/gloria-vip-signup.liquid. Sends the sign-up to
   * Klaviyo's client API as an event, which also creates or updates the
   * profile. The flow that sends the WhatsApp double opt-in listens to that
   * event; this script only hands the lead over.
   *
   * The client API is public by design (company id only, no secret), the same
   * endpoints Klaviyo's own onsite forms use.
   */
  (function () {
    var forms = document.querySelectorAll("[data-gl-vip-form]");
    if (!forms.length) return;

    var API = "https://a.klaviyo.com/client/";
    var REVISION = "2024-10-15";
    var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];

    // German numbers by default: "0151 2345678" -> "+491512345678". Anything
    // typed with a + or 00 prefix keeps its own country code.
    function normalizePhone(value) {
      var digits = value.replace(/[^\d+]/g, "");
      if (digits.indexOf("00") === 0) digits = "+" + digits.slice(2);
      if (digits.charAt(0) === "0") digits = "+49" + digits.slice(1);
      if (digits.charAt(0) !== "+") digits = "+49" + digits;
      return /^\+[1-9]\d{7,14}$/.test(digits) ? digits : null;
    }

    function readUtm() {
      var params = new URLSearchParams(window.location.search);
      var utm = {};
      UTM_KEYS.forEach(function (key) {
        if (params.get(key)) utm[key] = params.get(key);
      });
      return utm;
    }

    function post(path, companyId, body) {
      return fetch(API + path + "/?company_id=" + encodeURIComponent(companyId), {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: REVISION },
        body: JSON.stringify(body),
      }).then(function (response) {
        if (!response.ok) throw new Error("Klaviyo " + path + " " + response.status);
      });
    }

    function setUp(form) {
      var phoneInput = form.querySelector("[data-gl-vip-phone]");
      var emailInput = form.querySelector("[data-gl-vip-email]");
      var error = form.querySelector("[data-gl-vip-error]");
      var submit = form.querySelector("[data-gl-vip-submit]");
      var success = form.parentNode.querySelector("[data-gl-vip-success]");
      var data = form.dataset;

      function showError(message, input) {
        error.textContent = message;
        error.hidden = false;
        if (input) {
          input.setAttribute("aria-invalid", "true");
          input.focus();
        }
      }

      function clearError() {
        error.hidden = true;
        phoneInput.removeAttribute("aria-invalid");
        emailInput.removeAttribute("aria-invalid");
      }

      function showSuccess() {
        form.hidden = true;
        success.hidden = false;
        success.focus();
      }

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        clearError();

        // Honeypot filled: pretend it worked, send nothing.
        if (form.elements.website && form.elements.website.value) return showSuccess();

        var phone = normalizePhone(phoneInput.value);
        var email = emailInput.value.trim();
        if (!phone) return showError(data.errorPhone, phoneInput);
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          return showError(data.errorEmail, emailInput);
        }

        var tags = data.tags.split(",").map(function (tag) { return tag.trim(); }).filter(Boolean);
        var properties = Object.assign(
          { gl_vip_tags: tags, gl_vip_page: window.location.pathname },
          readUtm()
        );
        var profile = { phone_number: phone, properties: properties };
        if (email) profile.email = email;

        submit.disabled = true;

        var requests = [
          post("events", data.companyId, {
            data: {
              type: "event",
              attributes: {
                properties: properties,
                metric: { data: { type: "metric", attributes: { name: data.metric } } },
                profile: { data: { type: "profile", attributes: profile } },
              },
            },
          }),
        ];

        if (email && data.listId) {
          requests.push(
            post("subscriptions", data.companyId, {
              data: {
                type: "subscription",
                attributes: {
                  custom_source: tags.join(" "),
                  profile: { data: { type: "profile", attributes: { email: email } } },
                },
                relationships: { list: { data: { type: "list", id: data.listId } } },
              },
            })
          );
        }

        Promise.all(requests)
          .then(function () {
            showSuccess();
            if (typeof window.fbq === "function") window.fbq("track", "Lead");
          })
          .catch(function () {
            submit.disabled = false;
            showError(data.errorSubmit);
          });
      });
    }

    forms.forEach(setUp);

    // The closing button on the page jumps back up to the form; focusing the
    // phone field saves the visitor a tap (and opens the keyboard on phones).
    document.querySelectorAll("[data-gl-vip-jump]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        var phone = target.querySelector("[data-gl-vip-phone]");
        if (phone) phone.focus({ preventScroll: true });
      });
    });
  })();

  /**
   * Bundle picker A/B test, variant A
   * ---------------------------------
   * With `.gl-bundle-off` on <html> (set by the ABlyft variation), the
   * Needless Shots page buys like any product without a bundle:
   * assets/custom-ks.css takes the Fly Bundles widget away, and this undoes
   * what the app does to the theme's buy box and keeps it out of the
   * purchase.
   *
   * - The app may hide the theme's quantity picker, and depending on which
   *   of its selectors matches first the variant picker too, with inline
   *   styles on some wrapper around them. Every inline `display: none`
   *   between those controls and the form is lifted. (The add-to-cart
   *   button is hidden by the offer's CSS instead, and the variant picker
   *   only looked hidden - white colour circles on white; both are dealt
   *   with in assets/custom-ks.css.)
   * - The app adds a hidden field (properties[_modifyPayloadQB]) to the
   *   product form, which makes its request interceptor turn any
   *   add-to-cart into the selected tier - the 2-pack. The field is kept
   *   switched off, so the theme adds the picked variant in the picked
   *   quantity.
   * - The app writes its tier quantity into the theme's quantity field, so
   *   before an add-to-cart the field is set back to what the picker shows.
   * - The app writes the selected tier's price into the theme's price and
   *   button. Its single-tube tier is selected, whose price is the regular
   *   one, so the prices read as on any other product.
   *
   * The class is checked on every pass rather than once, so this also works
   * when it is set after load (ABlyft preview, devtools). All of it relies
   * on the app's class, attribute and field names.
   */
  (function () {
    var root = document.documentElement;
    var FORM = 'form[data-fly-bundles-form="true"]';
    var MARKERS = 'input[name="properties[_modifyPayloadQB]"], input[name="properties[_modifyPayloadPB]"]';
    // The theme's own controls. Which wrapper around them the app hides
    // depends on which of its many selectors matches first, so the path
    // from each control up to the form is cleared rather than a fixed list.
    var THEME_CONTROLS = '[data-add-to-cart], .product__selectors .selector-wrapper, input[name="quantity"]';
    // Clicks without the app ever marking the tier selected mean its markup
    // changed; past this many it stops trying.
    var MAX_CLICKS = 20;
    var clicks = 0;
    var scheduled = false;

    function active() {
      return root.classList.contains("gl-bundle-off");
    }

    // The app marks the product form; the theme's own button finds it too.
    function productForm() {
      var form = document.querySelector(FORM);
      if (form) return form;
      var button = document.querySelector(".product-single__details [data-add-to-cart]");
      return button && button.closest("form");
    }

    function showThemeControls(form) {
      form.querySelectorAll(THEME_CONTROLS).forEach(function (el) {
        for (; el && el !== form; el = el.parentElement) {
          if (el.style.display === "none") el.style.removeProperty("display");
        }
      });
    }

    // The click goes to the row's label container, where the app binds its
    // handler, and only once the app has marked it bound - before that, a
    // click would tick the radio without the app noticing. The app's
    // handler deselects a checked tier, so a checked one is left alone.
    function selectSingleTier() {
      var radio = document.querySelector(
        '.gfbVolumeDiscountWidgetWrapper input.gfbVolumeDiscountWidgetOfferDiscountTierRadio[value="1"]'
      );
      var tier = radio && radio.closest(".gfbVolumeDiscountWidgetOfferDiscountTierContainer");
      var label = tier && tier.querySelector(".gfbVolumeDiscountLabelContainer");
      if (!label || radio.checked || tier.classList.contains("gfbTierSelected")) return;
      if (label.dataset.isEventRegistered !== "REGISTERED") return;
      if (clicks++ >= MAX_CLICKS) return;
      label.click();
    }

    // The theme's quantity picker shows its value in a toggle and keeps it
    // in the quantity field; the app may have overwritten the field since.
    function syncQuantity(form) {
      var field = form.querySelector('input[name="quantity"]');
      var shown = form.querySelector("[data-quantity-select]");
      if (!field || !shown || !shown.offsetParent) return;
      var quantity = parseInt(shown.textContent, 10);
      if (quantity > 0) field.value = quantity;
    }

    function disableMarkers(form) {
      form.querySelectorAll(MARKERS).forEach(function (input) {
        input.disabled = true;
      });
    }

    function apply() {
      scheduled = false;
      if (!active()) return;
      var form = productForm();
      if (form) {
        showThemeControls(form);
        disableMarkers(form);
      }
      selectSingleTier();
    }

    // Coalesces the app's bursts of DOM writes into one check per frame.
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(apply);
    }

    // The theme sends the form with fetch from a click handler on its
    // button, without a submit event; a plain submit (no JS) goes through
    // the form. Both are caught in the capture phase, before the theme or
    // the app read the form - the markers again, in case the app has just
    // switched them back on.
    function beforeAdd(form) {
      if (!active() || !form || form !== productForm()) return;
      disableMarkers(form);
      syncQuantity(form);
    }

    document.addEventListener(
      "click",
      function (event) {
        var button = event.target.closest("[data-add-to-cart]");
        if (button) beforeAdd(button.form || button.closest("form"));
      },
      true
    );

    document.addEventListener(
      "submit",
      function (event) {
        beforeAdd(event.target);
      },
      true
    );

    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "data-is-event-registered"],
    });
    apply();
  })();

  /**
   * Heading, note and gift lines in the Needless Shots bundle picker
   * ----------------------------------------------------------------
   * "Wähle deine Kur" above the tiers and the note under them are not the
   * app's: snippets/gloria-kur-copy.liquid renders them from locales into a
   * <template>, and this copies them into the Fly Bundles widget of offer
   * VOL-825432 - the heading first in the box, the note right above the
   * add-to-cart button.
   *
   * The app's gift text is one string per tier, "Du sparst 34,80 € +
   * GRATIS Toner 100 ml". It is split at the "+" into a savings line and a
   * gift line, so assets/custom-ks.css can put them on two rows with the
   * gift's picture beside the second. A text without anything before the
   * "+" (the single tube) stays as it is.
   *
   * Tube 2 of the 18- and 12-week tiers starts on the other variant than
   * tube 1 - Deep next to Soft, Soft next to Deep - so a set holds both;
   * the app puts every tube on the same one. It is set by picking the
   * option in the app's dropdown each time a tier is opened, because the
   * app resets the tubes on every switch between tiers. Only within a
   * moment of that; a visitor's own pick afterwards is left alone. (A
   * change in the theme's own variant picker is not a trigger: the app
   * sets that picker itself, with real clicks, whenever a tube is picked,
   * so it cannot be told apart from a visitor's.)
   *
   * The app redraws the widget (on a variant change, for one), which drops
   * all of it, so an observer puts it back. Variant A of the bundle test
   * hides heading and note in CSS along with the tier rows.
   */
  (function () {
    var source = document.querySelector("template[data-gl-kur-copy]");
    var title = source && source.content.querySelector(".gl-kur-title");
    var note = source && source.content.querySelector(".gl-kur-note");
    var scheduled = false;

    // The app's tier indexes: tier-1 is the 18-week tier, tier-2 the
    // 12-week one. Items are the tubes, "0" the first.
    var TUBE_DEFAULT_TIERS = ["tier-1", "tier-2"];
    // Clicks per tier; -1 once tube 2 shows the other variant. The cap
    // stops the clicking if the app ignores them.
    var MAX_DEFAULT_CLICKS = 5;
    var defaultClicks = {};
    var openTier = null;
    // The default only applies right after a tier opens; later changes are
    // the visitor's own picks.
    var DEFAULT_WINDOW = 2500;
    var defaultsFrom = 0;

    function startDefaultWindow() {
      defaultsFrom = Date.now();
      // The app may finish its redraw without another DOM change to wake
      // the observer, so look again a few times within the window.
      [200, 600, 1200, 2000].forEach(function (delay) {
        setTimeout(schedule, delay);
      });
    }

    function line(className, text) {
      var span = document.createElement("span");
      span.className = className;
      span.textContent = text;
      return span;
    }

    function splitGiftText(el) {
      // Only the app's plain text; anything with markup is left alone.
      if (el.children.length) return;
      var text = el.textContent;
      var plus = text.indexOf("+");
      var savings = plus > 0 ? text.slice(0, plus).trim() : "";
      if (!savings) return;
      el.replaceChildren(line("gl-kur-savings", savings), line("gl-kur-gift", text.slice(plus).trim()));
    }

    // One tube's picker. The app draws it in one of two ways, depending on
    // the offer's settings: a native <select>, or its own dropdown of
    // radio labels. Both are read and set the way a visitor would.
    function tubePicker(box, tier, item) {
      var tube = box.querySelector(
        ".gfbVolumeDiscountTierContainer-VOL-825432-" + item + "-" + tier.replace("tier-", "")
      );
      if (!tube) return null;

      var select = tube.querySelector("select.gfbVolumeDiscountSingleDropdownSelector");
      if (select) {
        return {
          value: select.value,
          options: Array.prototype.map.call(select.options, function (option) {
            return option.value;
          }),
          ready: select.dataset.isEventRegistered === "REGISTERED",
          pick: function (value) {
            select.value = value;
            select.dispatchEvent(new Event("input", { bubbles: true }));
            select.dispatchEvent(new Event("change", { bubbles: true }));
          },
        };
      }

      var labels = tube.querySelectorAll("label.gfbDropdownMenuItem");
      var shown = tube.querySelector(".gfbSelectedMenuOption");
      if (!labels.length || !shown) return null;
      return {
        value: shown.textContent.trim(),
        options: Array.prototype.map.call(labels, function (label) {
          return label.dataset.optionValue;
        }),
        ready: labels[0].dataset.isEventRegistered === "REGISTERED",
        pick: function (value) {
          Array.prototype.forEach.call(labels, function (label) {
            if (label.dataset.optionValue === value) label.click();
          });
        },
      };
    }

    // Only the selected tier, and only once all its tubes are built. A
    // pick in a tier that is not selected makes the app rebuild it with the
    // selected tier's tube count (measured: the 18-week tier lost its third
    // tube while the 12-week one was selected) - and visitors only ever
    // pick in the open tier anyway. So the 18-week tier gets its default
    // when it is opened. A tier's radio carries its tube count as its value.
    function tierReady(box, tier) {
      var number = tier.replace("tier-", "");
      var radio = box.querySelector(
        'input.gfbVolumeDiscountWidgetOfferDiscountTierRadio[data-tier-count="' + number + '"]'
      );
      var card = radio && radio.closest(".gfbVolumeDiscountWidgetOfferDiscountTierContainer");
      if (!card || !card.classList.contains("gfbTierSelected")) return false;
      var tubes = box.querySelectorAll(
        ".gfbVolumeDiscountVariantSelectionContainer-VOL-825432-" + number + " > .gfbVolumeDiscountTierContainer"
      );
      return tubes.length >= parseInt(radio.value, 10);
    }

    function applyTubeDefaults(box) {
      // A newly opened tier starts over: the app has reset its tubes. While
      // the app redraws a tier, none is marked selected for a moment; that
      // is not a switch, or a visitor's own pick would be undone.
      var selected = box.querySelector(".gfbTierSelected input.gfbVolumeDiscountWidgetOfferDiscountTierRadio");
      var current = selected ? "tier-" + selected.dataset.tierCount : null;
      if (current && current !== openTier) {
        openTier = current;
        delete defaultClicks[current];
        startDefaultWindow();
      }
      if (Date.now() - defaultsFrom > DEFAULT_WINDOW) return;

      TUBE_DEFAULT_TIERS.forEach(function (tier) {
        var clicks = defaultClicks[tier] || 0;
        if (clicks < 0 || clicks >= MAX_DEFAULT_CLICKS) return;
        if (!tierReady(box, tier)) return;

        var first = tubePicker(box, tier, "0");
        var second = tubePicker(box, tier, "1");
        if (!first || !second) return;

        var target = second.options.filter(function (value) {
          return value !== first.value;
        })[0];
        if (!target) return;
        if (second.value === target) {
          defaultClicks[tier] = -1;
          return;
        }

        // Until the app has bound its handler, a pick would change the
        // control without the app noticing.
        if (!second.ready) return;
        defaultClicks[tier] = clicks + 1;
        second.pick(target);
      });
    }

    function apply() {
      scheduled = false;
      var box = document.querySelector(
        '.gfbVolumeDiscountWidgetWrapper[data-offer-id="VOL-825432"] .gfbVolumeDiscountWidgetOfferContainer'
      );
      if (!box) return;

      if (title && !box.querySelector(".gl-kur-title")) {
        box.prepend(title.cloneNode(true));
      }

      var button = box.querySelector(".gfbVolumeDiscountWidgetOfferAddToCartContainer");
      if (note && button && !box.querySelector(".gl-kur-note")) {
        button.before(note.cloneNode(true));
      }

      box.querySelectorAll(".gfbFreeGiftText").forEach(splitGiftText);
      applyTubeDefaults(box);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(apply);
    }

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "data-is-event-registered"],
    });
    apply();
  })();

  /**
   * Milky Toner size in "Was bekomme ich?" (Needless Shots)
   * --------------------------------------------------------
   * The toner that comes free with the bundle depends on the tier: 10 ml
   * with the 6- and 12-week tiers, 100 ml with the 18-week one. The section
   * in templates/product.needless-shots.json marks the size with
   * [data-gl-toner-size] and carries both texts in data-gl-size-small and
   * data-gl-size-large, so the copy stays in the template; this picks one
   * by the selected tier of offer VOL-825432. A tier's radio carries its
   * tube count as its value, three tubes being the 18-week tier.
   *
   * Variant A of the bundle test (.gl-bundle-off) sells single tubes, which
   * come with 10 ml. While the app redraws the widget, no tier is marked
   * selected for a moment; the size then stays as it is.
   */
  (function () {
    var targets = document.querySelectorAll("[data-gl-toner-size]");
    if (!targets.length) return;
    var scheduled = false;

    function apply() {
      scheduled = false;
      var large = false;
      if (!document.documentElement.classList.contains("gl-bundle-off")) {
        var radio = document.querySelector(
          '.gfbVolumeDiscountWidgetWrapper[data-offer-id="VOL-825432"] .gfbTierSelected input.gfbVolumeDiscountWidgetOfferDiscountTierRadio'
        );
        if (!radio) return;
        large = radio.value === "3";
      }

      targets.forEach(function (el) {
        var text = large ? el.dataset.glSizeLarge : el.dataset.glSizeSmall;
        if (text && el.textContent !== text) el.textContent = text;
      });
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(apply);
    }

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
    apply();
  })();

  /**
   * Bundle picker: the whole card selects, nothing deselects
   * --------------------------------------------------------
   * Fly Bundles binds its tier selection to the top row of each card (the
   * radio, title and prices). On the Needless Shots picker (offer
   * VOL-825432) two things change, both in one click listener that runs in
   * the capture phase on the document, before the app's handler:
   *
   * - A click anywhere else on an unselected card - the gift lines, the
   *   padding - is passed on to its row, so the whole card selects.
   * - A click on the selected card's row is stopped. The app would
   *   deselect the tier and leave the picker with none at all.
   *
   * Clicks elsewhere on the selected card, such as the tube dropdowns, go
   * through untouched.
   */
  document.addEventListener(
    "click",
    function (event) {
      var tier = event.target.closest(
        '.gfbVolumeDiscountWidgetWrapper[data-offer-id="VOL-825432"] .gfbVolumeDiscountWidgetOfferDiscountTierContainer'
      );
      if (!tier) return;

      var row = tier.querySelector(".gfbVolumeDiscountLabelContainer");
      if (!row) return;
      var onRow = row.contains(event.target);

      if (tier.classList.contains("gfbTierSelected")) {
        if (onRow) {
          event.preventDefault();
          event.stopPropagation();
        }
        return;
      }

      // The forwarded click lands on the row itself and passes through here
      // as an ordinary row click.
      if (!onRow) row.click();
    },
    true
  );

  /**
   * Gift pickers in the GG Creme bundle
   * -----------------------------------
   * Every free tube in offer VOL-115358 has its own shade picker, which the
   * app draws as a plain <select>: no colour beside it, and the phone's own
   * list when tapped. Each one gets
   *
   * - a dot in front of it, in the colour of the picked shade, and
   * - a list of its own - dot, name, a tick on the picked shade - in place
   *   of the native one, styled like the app's lists for the paid tubes.
   *   A pick sets the <select> and fires its change event the way a
   *   visitor's pick would, so the app takes it up as usual.
   *
   * The colours come from the app's own swatches in the same widget, so
   * they follow the shades as set up in the app. assets/custom-ks.css draws
   * dot and list (.gl-gift-swatch, .gl-shade-menu) and only lets taps
   * through to the list once it is there; without this script the <select>
   * works as before, and it stays the way in for the keyboard.
   *
   * The app redraws the widget on every tier switch, which drops both, so
   * an observer puts them back.
   */
  (function () {
    var WIDGET = '.gfbVolumeDiscountWidgetWrapper[data-offer-id="VOL-115358"]';
    var PICKER = "select.gfbVolumeDiscountFreeGiftsDropdownSelector";
    var FIELD = ".gfbFreeGiftProductOptionsWrapper";
    var scheduled = false;

    function shadeColor(widget, shade) {
      var swatch = widget.querySelector(
        'label.gfbDropdownMenuItem[data-option-value="' + CSS.escape(shade) + '"] .gfbDropdownMenuItemWrapper'
      );
      return swatch ? swatch.style.getPropertyValue("--custom-swatch-color").trim() : "";
    }

    function paintDot(field, color) {
      var dot = field.querySelector(".gl-gift-swatch");
      if (!color) {
        if (dot) dot.remove();
        return;
      }
      if (!dot) {
        dot = document.createElement("span");
        dot.className = "gl-gift-swatch";
        dot.setAttribute("aria-hidden", "true");
        field.prepend(dot);
      }
      dot.style.backgroundColor = color;
    }

    function buildMenu(select, widget) {
      var menu = document.createElement("div");
      menu.className = "gl-shade-menu";
      menu.setAttribute("role", "listbox");
      menu.hidden = true;
      Array.prototype.forEach.call(select.options, function (option) {
        var item = document.createElement("button");
        var swatch = document.createElement("span");
        item.type = "button";
        item.className = "gl-shade-menu__item";
        item.setAttribute("role", "option");
        item.dataset.glShade = option.value;
        swatch.className = "gl-shade-menu__swatch";
        swatch.style.backgroundColor = shadeColor(widget, option.value);
        item.append(swatch, option.textContent.trim());
        menu.append(item);
      });
      return menu;
    }

    function paint(select) {
      var widget = select.closest(WIDGET);
      var field = select.closest(FIELD);
      if (!widget || !field) return;
      paintDot(field, shadeColor(widget, select.value));

      var menu = field.querySelector(".gl-shade-menu");
      if (!menu) {
        menu = buildMenu(select, widget);
        field.append(menu);
      }
      menu.querySelectorAll(".gl-shade-menu__item").forEach(function (item) {
        item.setAttribute("aria-selected", item.dataset.glShade === select.value ? "true" : "false");
      });
    }

    function closeMenus(except) {
      document.querySelectorAll(WIDGET + " .gl-shade-menu:not([hidden])").forEach(function (menu) {
        if (menu !== except) menu.hidden = true;
      });
    }

    function pick(item) {
      var select = item.closest(FIELD).querySelector(PICKER);
      closeMenus();
      if (!select || select.value === item.dataset.glShade) return;
      select.value = item.dataset.glShade;
      select.dispatchEvent(new Event("input", { bubbles: true }));
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function apply() {
      scheduled = false;
      document.querySelectorAll(WIDGET + " " + PICKER).forEach(paint);
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(apply);
    }

    // A tap on a picker's box toggles its list, a tap on a shade picks it,
    // and a tap anywhere else closes any open list.
    document.addEventListener("click", function (event) {
      var item = event.target.closest(WIDGET + " .gl-shade-menu__item");
      if (item) {
        pick(item);
        return;
      }
      var box = event.target.closest(WIDGET + " " + FIELD + " .gfbDropdownWithCustomIcon");
      var menu = box && box.closest(FIELD).querySelector(".gl-shade-menu");
      closeMenus(menu);
      if (menu) menu.hidden = !menu.hidden;
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeMenus();
    });

    document.addEventListener("change", function (event) {
      if (event.target.matches && event.target.matches(WIDGET + " " + PICKER)) paint(event.target);
    });

    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    apply();
  })();

  /**
   * Variant image in the first gallery slot
   * ---------------------------------------
   * Opt-in per template via gl_variant_media_swap (sections/product.liquid),
   * and only in variant A of the bundle test (.gl-bundle-off on <html>, set
   * by ABlyft). The stock theme only jumps to wherever the variant image sits
   * in the gallery, which for images added late is the very end.
   *
   * snippets/product.liquid renders the page for variant B: the cover
   * product's image first (gl_bundle_cover_product) and every variant image
   * parked in a hidden holder. For A this swaps the variant's image into
   * slot 0 - slider and thumbnails - once on load and again on every variant
   * change, and sends the previous one back to the holder. B is left as
   * rendered.
   *
   * The load pass runs before the theme builds its slider and zoom on
   * DOMContentLoaded, so both pick up the swapped gallery. The theme's own
   * jump on a variant change either finds the image at index 0 or, still
   * parked, outside the slider - both leave it alone.
   */
  (function () {
    var ZOOM_ATTRIBUTES = ["href", "data-image-width", "data-image-height"];

    function variantA() {
      return document.documentElement.classList.contains("gl-bundle-off");
    }

    // The theme bundles Flickity in vendor.js and exposes it only here, not
    // as window.Flickity.
    function sliderOf(list) {
      var Flickity = window.themeVendor && window.themeVendor.Flickity;
      return list && Flickity ? Flickity.data(list) : null;
    }

    // What belongs to slot 0 rather than to the image moves along with it:
    // the "30 Tage" badge the theme only renders on the first image, and the
    // zoom link. The theme's zoom keeps the links it found on load as a fixed
    // list and reads their targets on click; parked slides carry a dormant
    // link (data-gl-zoom-wrapper) that is not in that list, so the live link
    // of slot 0 takes over the new image.
    function handOverSlot(outgoing, incoming) {
      var badge = outgoing.querySelector(".tage-30-badge");
      var media = incoming.querySelector(".product-single__media");
      if (badge && media && !media.querySelector(".tage-30-badge")) {
        media.insertBefore(badge, media.firstChild);
      }

      var live = outgoing.querySelector("[data-zoom-wrapper]");
      var dormant = incoming.querySelector("[data-gl-zoom-wrapper]");
      if (!live || !dormant) return;

      ZOOM_ATTRIBUTES.forEach(function (name) {
        var value = live.getAttribute(name);
        live.setAttribute(name, dormant.getAttribute(name));
        dormant.setAttribute(name, value);
      });

      var marker = document.createComment("");
      live.replaceWith(marker);
      dormant.replaceWith(live);
      marker.replaceWith(dormant);
    }

    // Moves `id` from the holder to the front of the list. The first item
    // only goes back to the holder when it may leave slot 0 - a variant
    // image or the cover image - so a variant without an image of its own
    // never parks the product's photo.
    function swapIntoFirstSlot(list, holder, swappableIds, id) {
      var incoming = holder && holder.querySelector('[data-id="' + id + '"]');
      if (!list || !incoming) return;

      var flkty = sliderOf(list);
      var first = flkty
        ? flkty.cells[0] && flkty.cells[0].element
        : list.querySelector("[data-id]");
      var outgoing =
        first && swappableIds.indexOf("," + first.getAttribute("data-id") + ",") !== -1
          ? first
          : null;

      if (flkty) {
        if (outgoing) flkty.remove(outgoing);
        flkty.prepend(incoming);
      } else {
        list.insertBefore(incoming, first && first.parentNode === list ? first : list.firstChild);
      }
      if (outgoing) {
        handOverSlot(outgoing, incoming);
        holder.appendChild(outgoing);
      }
    }

    function showVariantMedia(gallery, id) {
      var holder = gallery && gallery.querySelector("[data-gl-variant-media]");
      if (!holder || !id || !variantA()) return;

      var swappableIds = holder.getAttribute("data-gl-variant-media");
      var slider = gallery.querySelector("[data-product-single-media-slider]");

      swapIntoFirstSlot(slider, holder, swappableIds, id);
      swapIntoFirstSlot(
        gallery.querySelector("[data-product-single-media-thumbs]"),
        gallery.querySelector("[data-gl-variant-thumbs]"),
        swappableIds,
        id
      );

      var flkty = sliderOf(slider);
      if (flkty) flkty.select(0, false, true);
    }

    document.querySelectorAll("[data-gl-variant-media]").forEach(function (holder) {
      showVariantMedia(
        holder.closest("[data-product-single-media-group]"),
        holder.getAttribute("data-gl-current-media")
      );
    });

    document.addEventListener("theme:variant:change", function (event) {
      var media = event.detail && event.detail.variant && event.detail.variant.featured_media;
      if (!media) return;

      showVariantMedia(event.target.querySelector("[data-product-single-media-group]"), media.id);
    });
  })();

  /**
   * Product title with the selected variant
   * ---------------------------------------
   * The title block's gl_variant_title setting (sections/product.liquid) is
   * a pattern such as "Needless Shot [variante]". Liquid renders it for the
   * variant on load, next to the product title, and leaves the pattern on
   * it; assets/custom-ks.css shows it in variant A of the bundle test only.
   * This keeps it in step when the variant changes without a reload.
   */
  document.addEventListener("theme:variant:change", function (event) {
    var variant = event.detail && event.detail.variant;
    var title = variant && event.target.querySelector("[data-gl-variant-title]");
    if (!title) return;

    title.textContent = title.getAttribute("data-gl-variant-title").split("[variante]").join(variant.title);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
